const validatePersonalData = (values, t) => {
  const errors = {}

  if (!values.personal_data.first_name) {
    errors.personal_data = {
      ...errors.personal_data,
      first_name: t("formData.requiredfield"),
    }
  }

  if (!values.personal_data.last_name) {
    errors.personal_data = {
      ...errors.personal_data,
      last_name: t("formData.requiredfield"),
    }
  }

  if (!values.personal_data.country) {
    errors.personal_data = {
      ...errors.personal_data,
      country: t("formData.Select"),
    }
  }

  if (!values.personal_data.phone) {
    errors.personal_data = {
      ...errors.personal_data,
      phone: t("formData.requiredfield"),
    }
  }

  if (!values.personal_data.email) {
    errors.personal_data = {
      ...errors.personal_data,
      email: t("formData.requiredfield"),
    }
  }

  if (!values.personal_data.personal_data_rights) {
    errors.personal_data = {
      ...errors.personal_data,
      personal_data_rights: t("formData.requiredprivacy"),
    }
  }

  return errors
}

export default validatePersonalData
